import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

// material-ui
import withStyles from '@material-ui/core/styles/withStyles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import AppBar from '@material-ui/core/AppBar';

// components
import RulesList from 'components/RulesList';
import Loading from 'components/Loading';
import FormRule from 'components/FormRule';

// styles
import styles from './styles';

class WrapperRulePage extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    refresh: PropTypes.func,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    loading: PropTypes.bool,
    rules: PropTypes.array,
    createRule: PropTypes.func,
    deleteRule: PropTypes.func,
    updateRule: PropTypes.func,

    // roles
    roles: PropTypes.array,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedRule: undefined,
      formRuleOpen: false,
    };
  }

  getStepContent() {
    const { index } = this.state;
    const { rules } = this.props;

    switch (index) {
      case 0:
        return (
          <RulesList
            rules={rules}
            onSelect={selectedRule => this.setState({
              selectedRule,
              formRuleOpen: true,
            })}
          />
        );
      default:
    }

    return [];
  }

  render() {
    const {
      classes,
      history,
      loading,
      createRule,
      deleteRule,
      updateRule,
      refresh,
      roles,
    } = this.props;

    const {
      index,
      selectedRule,
      formRuleOpen,
    } = this.state;

    return (
      <div className={`${classes.background} page`}>
        {
          loading
            ? (
              <Loading
                message={'Fetching all Rules'}
              />
            )
            : (
              <div>
                <Helmet>
                  <title>Rules</title>
                  <meta name="MyAccount" content="MyAccount page" />
                </Helmet>
                <AppBar position="static" className={classes.appBar}>
                  <Tabs
                    value={index}
                    onChange={(e, v) => {
                      this.setState({
                        index: v,
                      });
                      history.push(`?index=${v}`);
                    }}

                    indicatorColor="primary"
                    textColor="primary"
                    scrollable
                    scrollButtons="auto"
                    classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                  >
                    <Tab
                      label="All"
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                    />
                  </Tabs>
                </AppBar>
                <div className="container withAppBarAndTabs">
                  {
                    this.getStepContent()
                  }
                </div>
              </div>
            )
        }
        <Button
          variant="fab"
          color="primary"
          aria-label="Add"
          className={classes.floatingActionButton}
          onClick={() => this.setState({ formRuleOpen: true })}
        >
          <AddIcon />
        </Button>
        <FormRule
          open={formRuleOpen}
          rule={selectedRule}
          close={() => {
            this.setState({
              formRuleOpen: false,
            });
            setTimeout(() => this.setState({
              selectedRule: undefined,
            }), 200);
          }
          }
          createRule={createRule}
          deleteRule={deleteRule}
          updateRule={updateRule}
          refresh={refresh}
          roles={roles}
        />
      </div>
    );
  }
}
export default withStyles(styles)(WrapperRulePage);
